import type { NsDict } from '../ru';

export const auth: NsDict<'auth'> = {
  lead: 'Prognostizieren Sie die Bewegung eines verdeckten Index aus drei S&P-500-Aktien. Zuerst nur der Chart, dann die Skala und erst in der letzten Runde die Zusammensetzung.',
  point1b: '4–8 Spieler',
  point1: 'pro Tisch, drei Einsatzrunden zu je einer Minute',
  point2b: 'Prüfbare Abrechnung:',
  point2: 'ein signiertes Paket mit Kursen und Buchungen',
  point3b: 'Verlauf und Statistik',
  point3: 'aller Ihrer Spiele im Profil',
  demo: 'Demo: Bei der Registrierung erhalten Sie {amount|cr} Spiel-Credits. Kein echtes Geld.',
  tabLogin: 'Anmelden',
  tabRegister: 'Registrieren',
  login: 'Benutzername',
  loginPh: 'lateinische Buchstaben, Ziffern, . _ -',
  name: 'Name am Tisch',
  namePh: 'z. B. Irina',
  password: 'Passwort',
  passwordHint: 'mindestens 8 Zeichen, Buchstaben und Ziffern',
  password2: 'Passwort wiederholen',
  mismatch: 'Passwörter stimmen nicht überein',
  submitLogin: 'Anmelden',
  submitRegister: 'Registrieren',
  or: 'oder mit',
  created: 'Konto erstellt. Den Namen am Tisch können Sie im Profil ändern.',
  linked: '{provider}: Konto mit dem Profil verknüpft',
  failed: 'Anmeldung fehlgeschlagen',
  'provider.yandex': 'Yandex',
  'mark.yandex': 'Y',
};
